import React, { useEffect } from "react";
import Html from "../assets/html.png";
import Css from "../assets/css.png";
import Javascript from "../assets/javascript.png";
import Reactp from "../assets/react.png";
import Node from "../assets/node.png";
import Tailwind from "../assets/tailwind.png";
import Bootstrap from "../assets/bootstrap.png";
import Mongodb from "../assets/mongodb.png";
import Express from "../assets/express.png";
import Python from "../assets/python.png";
import Firebase from "../assets/firebase.png";
import Mysql from "../assets/mysql.png";
import { useSpring, animated } from "react-spring";

const FrontendSkills = () => {
  return (
    <div className="py-7 px-12 mx-auto mt-8 border h-fit">
      <p className="mb-4 text-center">FRONTEND</p>
      <div className="grid grid-cols-2 mx-auto text-center text-[17px] gap-6 md:gap-10 w-full">
        <div className="skills-div  shadow-[#E44D26]">
          <img className="skills-img" src={Html} alt="HTML" />
          <p className="">HTML</p>
        </div>
        <div className="skills-div shadow-[#0277BD]">
          <img className="skills-img" src={Css} alt="CSS" />
          <p className="my-2">CSS</p>
        </div>
        <div className="skills-div shadow-[#FFD600]">
          <img className="skills-img" src={Javascript} alt="JavaScript" />
          <p className="my-2">JavaScript</p>
        </div>
        <div className="skills-div shadow-[#00D7FE]">
          <img className="skills-img" src={Reactp} alt="React" />
          <p className="my-2">ReactJS</p>
        </div>
        <div className="skills-div shadow-[#00D7FE]">
          <img className="skills-img" src={Tailwind} alt="React" />
          <p className="my-2">Tailwind</p>
        </div>
        <div className="skills-div shadow-[#00D7FE]">
          <img className="skills-img" src={Bootstrap} alt="React" />
          <p className="my-2">Bootstrap</p>
        </div>
      </div>
    </div>
  );
};

const BackendSkills = () => {
  return (
    <div className="py-7 px-12 mx-auto mt-8 border h-fit">
      <p className="mb-4 text-center">BACKEND</p>
      <div className="grid grid-cols-2 mx-auto text-center text-[17px] gap-6 md:gap-10 w-full">
        <div className="skills-div shadow-[#8CC84B]">
          <img className="skills-img" src={Node} alt="Node" />
          <p className="my-2">NodeJS</p>
        </div>
        <div className="skills-div shadow-[#8CC84B]">
          <img className="skills-img" src={Mongodb} alt="MongoDB" />
          <p className="my-2">MongoDB</p>
        </div>
        <div className="skills-div shadow-[#8CC84B]">
          <img className="skills-img" src={Python} alt="MongoDB" />
          <p className="my-2">Python</p>
        </div>
        <div className="skills-div shadow-white">
          <img className="skills-img" src={Express} alt="Github" />
          <p className="my-2">ExpressJS</p>
        </div>
        <div className="skills-div shadow-white">
          <img className="skills-img" src={Mysql} alt="Github" />
          <p className="my-2">MySQL</p>
        </div>
        <div className="skills-div shadow-white">
          <img className="skills-img" src={Firebase} alt="Github" />
          <p className="my-2">Firebase</p>
        </div>
      </div>
    </div>
  );
};

const Skills = () => {
  const [isVisible, setVisible] = React.useState(false);
  const [animationComplete, setAnimationComplete] = React.useState(false);

  const springProps = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateX(0%)" : "translateX(100%)",
    config: { duration: 1200 },
    onRest: () => {
      setAnimationComplete(true);
    },
  });

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const skillsSection = document.getElementById("skills-section");
    const triggerPosition = skillsSection.offsetTop - window.innerHeight / 2;
    setVisible(animationComplete || scrollPosition > triggerPosition);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [animationComplete]);

  return (
    <section
      id="skills-section"
      name="skills"
      className="flex flex-col justify-center items-center min-h-screen w-full bg-gradient-to-br from-[#0F172A] to-[#183250] text-slate-50"
    >
      <div className="max-w-[1000px] mx-auto p-6 w-full">
        <animated.p
          style={springProps}
          className="mx-auto mb-10 text-4xl border-b-4 border-yellow-500 sm:text-5xl w-fit"
        >
          Skills
        </animated.p>
        <div>
          <div className="flex flex-col sm:flex-row">
            {/* Frontend Skills */}
            <FrontendSkills />

            {/* Backend Skills */}
            <BackendSkills />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
